<script>
const classNames = "customForm";
import componentcustom from "./customComponent1.vue";
import { deepClone } from "lodash-unified";
import "./customForm.less";
export default {
  props: {
    items:{
      type: Object,
      default: undefined,
    },
    // Component: {
    //   type: Object,
    //   default: undefined,
    // },
    // label: {
    //   type: String,
    //   default: "",
    // },
    // prop: {
    //   type: String,
    //   default: "",
    // },
    // defaultValue: {
    //   type: [Array, String, Object, Number],
    //   default: undefined,
    // },
    // formSlots: {
    //   type: Function,
    //   default: () => {},
    // },
    // renderHTML: {
    //   type: Function,
    //   default: () => {},
    // },
    // beforeSlot: {
    //   type: Function,
    //   default: () => {},
    // },
    // afterSlot: {
    //   type: Function,
    //   default: undefined,
    // },
    // childSlot: {
    //   type: Array,
    //   default: undefined,
    // },
    // render: {
    //   type: Function,
    //   default: undefined,
    // },
    // formProps: {
    //   type: Object,
    //   default: undefined,
    // },
    // componentProps: {
    //   type: Object,
    //   default: () => {},
    // },
    // on: {
    //   type: Object,
    //   default: () => {},
    // },
    // ruleForm: {
    //   type: Object,
    //   default: () => {},
    // },
    // componentSlots: {
    //   type: Object,
    //   default: () => {},
    // },
    // id: {
    //   type: Number,
    //   default: 0,
    // },
  },
  compontents: {
    componentcustom,
  },
  inject: ["ruleForms"],
  computed: {
    defaultValues: {
      get() {
        if (this.ruleForms[this.items.prop]) {
          const val = this.ruleForms
          return val[this.items.prop];
        } else {
          const val = this.items
          this.$set(this.ruleForms,val.prop,val.defaultValue)
          return val.defaultValue;
        }
      },
      set(news) {
        // this.ruleForms[this.items.prop] = news
        this.$set(this.ruleForms,this.items.prop,news)
      },
    },
  },
  render(h) {
    return  <el-form-item rules={this.items.formProps.rules} style='"margin-bottom": "36px",'  prop={this.items.prop} label={this.items.label}>
      <div class={classNames + "_coustom_item"}>
              {this.items.beforeSlot && this.items.beforeSlot(h)}
              {this.items.render && this.items.render(h) ? (
                this.items.render(h)
              ) : (
                <componentcustom
                  items={this.items}
                  v-model={this.defaultValues} 
                  scopedSlots={{...this.items.componentSlots}}
                ></componentcustom>
              )}
              {this.items.afterSlot && this.items.afterSlot(h)}
            </div>
      </el-form-item>
   
    // h(
    //   "el-form-item",
    //   {
    //     style: {
    //       "margin-bottom": "36px",
    //     },
    //     ...this.formProps,
    //     prop: this.prop,
    //     label: this.label,
    //   },
    //   {
    //     ...this.formSlots,
    //     default: () => {
    //       return (
    //         <div class={classNames + "_coustom_item"}>
    //           {this.beforeSlot && this.beforeSlot(h)}
    //           {this.render ? (
    //             this.render(h, deepClone(this))
    //           ) : (
    //             <componentcustom
    //               items={this}
    //               v-slots={{
    //                 ...this.componentSlots,
    //               }}
    //               v-model={this.defaultValue}
    //             ></componentcustom>
    //           )}
    //           {this.afterSlot && this.afterSlot(h)}
    //         </div>
    //       );
    //     },
    //   }
    // );
  },
};
</script>
